import { memo } from "react";

import { isNative } from "@stepapp/core";
import { Block, LinePlaceholder, Typography } from "@stepapp/ui";

type Props = {
  name: string;
  isRequired?: boolean;
};

type ServiceSceneDescriptionProps = {
  description: string;
  marginBottom?: number;
  loading?: boolean;
};

export const ServiceSceneHeader = memo(({ name, isRequired = false }: Props) => {
  return (
    <Block marginTop={2}>
      <Typography variant={isNative ? "newH3" : "body"}>
        {name}{" "}
        {isRequired && (
          <Typography type="error" variant="body">
            *
          </Typography>
        )}
      </Typography>
    </Block>
  );
});

export const ServiceSceneDescription = memo(
  ({ description, marginBottom = 0, loading }: ServiceSceneDescriptionProps) => {
    if (loading) {
      return (
        <Block marginTop={1} marginBottom={marginBottom}>
          <LinePlaceholder height={2.5} />
        </Block>
      );
    }

    return description ? (
      <Block marginTop={1} marginBottom={marginBottom}>
        <Typography type="secondary" variant="lightLabel">
          {description}
        </Typography>
      </Block>
    ) : null;
  },
);
